import { BASE_PATH_API } from '@root/manager-base/app-base/environment/paths/constants';
import { createActions } from '@manager-base/app-base/config/data-access';
import { CreateUpdateProjectTemplateDto } from '@root/app/projects/data/dto/create-update-project-template-dto';
import { ProjectTemplateDto } from '@app/projects/data/dto/project-template-dto';

const routeRoot = 'v1/projectTemplates';
const baseRoute = `${BASE_PATH_API}/${routeRoot}`;

const actions = {
    getProjectTemplates: {
        method: 'GET',
        url: baseRoute,
        params: {
            '$count': true
        }
    },
    createProjectTemplate: {
        method: 'POST',
        url: baseRoute,
    },
    getProjectTemplate: {
        method: 'GET',
        url: `${baseRoute}/:id`,
    },
    getActiveProjectsAssociatedWithTemplate: {
        method: 'GET',
        url: `${baseRoute}/:id/projects`,
        params: {
            '$count': true
        }
    },
    editProjectTemplate: {
        method: 'PUT',
        url: `${baseRoute}/:id`,
    },
    deleteProjectTemplate: {
        method: 'DELETE',
        url: `${baseRoute}/:id`,
    }
};

export interface IProjectTemplatesApi {
    createProjectTemplate(CreateUpdateProjectTemplateDTO: CreateUpdateProjectTemplateDto): Promise<ProjectTemplateDto>;
    getProjectTemplate(params: { id: number }): Promise<ProjectTemplateDto>;
    getProjectTemplates(params: any): Promise<any>;
    getActiveProjectsAssociatedWithTemplate(params: { id: number }): Promise<any>;
    editProjectTemplate(params: { id: number }, editProjectTemplateDto: CreateUpdateProjectTemplateDto): Promise<ProjectTemplateDto>;
    deleteProjectTemplate(params: { id: number });
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function ProjectTemplatesApi(): IProjectTemplatesApi {
    return createActions(actions);
}
